var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('iframe',{staticClass:"iframe",attrs:{"src":'../../../static/pdf/web/viewer.html?file=' + _vm.pdfUrl,"frameborder":"0"}})])}
var staticRenderFns = []

export { render, staticRenderFns }